module.exports = __webpack_public_path__ + "static/media/vip2.46fe9a84.png";